import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectIcon20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMediaObjectIcon20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 3.5H3.5q-.122 0-.235.028L6.75 8.664l3.485-5.136A1 1 0 0 0 10 3.5m1 1.573L7.656 10 11 14.928zM5.844 10 2.5 5.073v9.855zm-2.58 6.472 3.486-5.136 3.485 5.136A1 1 0 0 1 10 16.5H3.5q-.122 0-.235-.028M3.5 2A2.5 2.5 0 0 0 1 4.5v11A2.5 2.5 0 0 0 3.5 18H10a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 10 2zM15 5.5A.75.75 0 0 0 15 7h3.238a.75.75 0 0 0 0-1.5zm-.75 4.25A.75.75 0 0 1 15 9h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectIcon20);
